module.exports = __webpack_public_path__ + "img/light.80376cec.png";